module.exports = "<!-- Footer -->\r\n<nav class=\"navbar fixed-bottom navbar-light bg-light ip-no-padding\">\r\n  <mat-toolbar color=\"primary\">\r\n    <div class=\"ip-fill-space\">\r\n      <span class=\"ip-small-header\">{{footer|uppercase}}</span>\r\n    </div>\r\n    <div *ngIf=\"copyright\" class=\"ip-right-align ip-small-header\">\r\n      <span>&copy; {{copyright}}</span>\r\n    </div>\r\n  </mat-toolbar>\r\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/portal-footer/portal-footer.component.html
// module id = ./src/app/components/portal-footer/portal-footer.component.html
// module chunks = main